export class TimedFunction {
  private static tickRate = 1000
  timer = 0
  interval: number | undefined

  constructor(private func: Function, private callTime) {
    this.start()
  }

  start(): void {
    if (this.interval || this.callTimeHasPassed()) {
      return
    }
    // @ts-ignore  Typing things setInterval returns a NodeJS instance but this is Browser instead
    this.interval = setInterval(() => this.tick(), TimedFunction.tickRate)
  }

  pause(): void {
    if (this.interval) {
      clearInterval(this.interval)
    }
    this.interval = undefined
  }

  private tick(): void {
    this.timer++
    if (this.timer === this.callTime) {
      this.func()
      clearInterval(this.interval)
    }
  }

  private callTimeHasPassed(): boolean {
    return this.timer >= this.callTime
  }
}
